<p-columnFilter class="number-range-filter" matchMode="" showClearButton="false" showMatchModes="false" type="numeric"
  [field]="field" showMenu="false">
  <ng-template pTemplate="filter">
    <div class="number-range-inputs">
      <p-inputnumber [formControl]="control" inputId="start" mode="decimal" [useGrouping]="false" [min]="1"
        [(ngModel)]="startNumber" placeholder="Inicio" (onBlur)="filterInput($event)" size="small" />
      <span>-</span>
      <p-inputnumber [formControl]="controlAlter" inputId="end" mode="decimal" [useGrouping]="false" [min]="1"
        [(ngModel)]="endNumber" placeholder="Fin" (onBlur)="filterInput($event)" size="small" />
    </div>
  </ng-template>
</p-columnFilter>